import { Slot } from '@radix-ui/react-slot';
import * as React from 'react';

import { cn } from '@heidi/utils';

import type { ButtonProps } from './button.types';
import { useButtonProps } from './use-button-props';

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      className,
      variant,
      size,
      asChild = false,
      iconOnly,
      disableAutomaticTypographyClasses,
      activeClassName,
      onClick,
      disableAutomaticSvgSizing,
      flush,
      ...props
    },
    ref
  ) => {
    // Shared with every other surface that wears a button recipe without
    // rendering a `Button` — see `use-button-props.ts`.
    const buttonProps = useButtonProps({
      variant,
      size,
      iconOnly,
      flush,
      disableAutomaticTypographyClasses,
      disableAutomaticSvgSizing,
    });

    const Comp = asChild ? Slot : 'button';
    return (
      <Comp
        {...buttonProps}
        className={cn(buttonProps.className, className, activeClassName)}
        ref={ref}
        onClick={onClick}
        {...props}
      />
    );
  }
);
Button.displayName = 'Button';

export { Button };
